<template>
  <div class="aulas-instrutor-modal">
    <div v-if="loading" class="loading-container">
      <LoadingSpinner />
      <p>Carregando aulas do instrutor...</p>
    </div>

    <div v-else-if="aulas && aulas.length > 0" class="content-section">
      <div class="info-card">
        <h4 class="info-title">Informações da Consulta</h4>
        <div class="info-grid">
          <div class="info-item">
            <label class="info-label">Data</label>
            <span class="info-value">{{ utils.formatOnlyDate(data) }}</span>
          </div>
          <div class="info-item">
            <label class="info-label">Total de Aulas</label>
            <span class="info-value">{{ aulas.length }}</span>
          </div>
        </div>
      </div>

      <div class="table-container">
        <Table
          :headers="['Aluno', 'Hodômetro', 'Data', 'Início (Previsto)', 'Fim (Previsto)', 'Início (Real)', 'Fim (Real)', 'Dupla', 'Status', 'Ações']">
          <horario-aula-instrutor v-for="aula in aulas" :key="aula.idAnotacaoPratica" :response="aula"
            :aulaId="aula.idAnotacaoPratica" :aluno="aula.aluno" :inicio="aula.inicio" :fim="aula.fim" :schema="schema"
            :aulas="aula.aulas" @update-aulas="updateAulas()" />
        </Table>
      </div>
    </div>

    <div v-else class="empty-state">
      <FileDocumentAlertOutline :size="64" color="#9E9E9E" />
      <h4>Nenhuma aula encontrada</h4>
      <p>Não foram encontradas aulas para este instrutor na data selecionada.</p>
    </div>

    <div class="modal-actions">
      <Button text="Fechar" color="primary" @handle:click="closeModal">
        <Close :size="18" />
      </Button>
    </div>
  </div>
</template>
<script>
import urlApi from '@/router/urlApiV2'
import utils from '@/services/utils'

// Componentes Core
import Button from 'core/Button'
import LoadingSpinner from 'core/LoadingSpinner'
import Table from 'core/Table'

// Ícones
import Close from 'icons/Close'
import FileDocumentAlertOutline from 'icons/FileDocumentAlertOutline'

// Componente específico
import HorarioAulaInstrutor from './HorarioAulaInstrutor'

export default {
  name: 'AulasInstrutorModal',
  components: {
    Button,
    LoadingSpinner,
    Table,
    Close,
    FileDocumentAlertOutline,
    HorarioAulaInstrutor
  },
  props: {
    instrutor: Number,
    schema: String,
    data: String,
  },
  data() {
    return {
      aulas: null,
      loading: false,
      utils,
    }
  },
  mounted() {
    this.queryAulasInstrutor()
  },
  methods: {
    formatDate(dateString) {
      console.log(dateString)
      if (!dateString) return ''
      return utils.formatDate(dateString) || dateString
    },

    async queryAulasInstrutor() {
      this.loading = true

      try {
        const response = await this.$http.get(`${urlApi}/instrutor/aulas/praticas`, {
          params: {
            id: this.instrutor,
            schema: this.schema,
            de: this.data,
            ate: this.data
          }
        })

        if (response.data.success) {
          this.aulas = response.data.dados
        } else {
          this.$toasted.show('Erro ao carregar aulas do instrutor', {
            position: 'top-right',
            type: 'error'
          })
        }
      } catch (error) {
        console.error('Erro ao carregar aulas do instrutor:', error)
        this.$toasted.show('Erro ao carregar aulas do instrutor', {
          position: 'top-right',
          type: 'error'
        })
        this.aulas = []
      } finally {
        this.loading = false
      }
    },

    updateAulas() {
      this.aulas = []
      this.queryAulasInstrutor()
    },

    closeModal() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="scss" scoped>
.aulas-instrutor-modal {
  min-width: 800px;

  @media (max-width: 768px) {
    min-width: auto;
    max-width: 95vw;
  }
}

.modal-title {
  margin: 0 0 1.5rem 0;
  color: #202224;
  font-size: 1.5rem;
  font-weight: 600;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  text-align: center;

  p {
    margin-top: 1rem;
    color: #6b7280;
    font-size: 0.875rem;
  }
}

.content-section {
  margin-bottom: 2rem;
}

.info-card {
  background-color: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  padding: 1.5rem;
  margin-bottom: 1.5rem;

  .info-title {
    margin: 0 0 1rem 0;
    color: #374151;
    font-size: 1.125rem;
    font-weight: 600;
  }
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
}

.info-item {
  .info-label {
    display: block;
    font-size: 0.75rem;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    margin-bottom: 0.25rem;
  }

  .info-value {
    font-size: 0.875rem;
    color: #374151;
    font-weight: 500;
  }
}

.aulas-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 800px;

  th {
    background-color: #f8fafc;
    padding: 1rem 0.75rem;
    text-align: left;
    font-weight: 600;
    color: #374151;
    font-size: 0.875rem;
    border-bottom: 1px solid #e5e7eb;
    white-space: nowrap;

    &:first-child {
      border-top-left-radius: 0.75rem;
    }

    &:last-child {
      border-top-right-radius: 0.75rem;
    }
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 3rem 1rem;

  h4 {
    margin: 1rem 0 0.5rem 0;
    color: #202224;
    font-size: 1.25rem;
    font-weight: 600;
  }

  p {
    margin: 0;
    color: #6b7280;
    font-size: 0.875rem;
    max-width: 400px;
    line-height: 1.5;
  }
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 1rem;
  border-top: 1px solid #e9ecef;
}

// Responsividade
@media (max-width: 992px) {
  .aulas-table {
    font-size: 0.75rem;

    th,
    td {
      padding: 0.5rem;
    }
  }
}
</style>
